import { saveSelectedStore } from "../../../../global/js/findInStore";
import { isLoggedin } from "../../../../global/js/utils";
import { spinnerService } from "../../../../global/js/spinnerService";

const NS = 'RegionStoreSelector';
const CLS = 'regionStoreSelector';
const CLS_SHOW_REGION = 'show-region';
const CLS_SHOW_STORE = 'show-store';
const CLS_IS_LOADING = 'is-loading';
const CLS_IS_SELECTED = 'is-selected';
const TXT_STORE = 'Choose Your Store';
const TXT_REGION = 'Choose Region';
const EVT_SET_REGION = `${CLS}.setRegion`;

// TODO
// - on hide dropdown, set show store/region, check if store has been selected first
// - on click region, check regionId

export class RegionStoreSelector {
	constructor(el) {
		// $el is the widget node return by the loadRegionStoreSelector function
		this.el = el;
		this.$el = $(el);
		this.$dropdown = this.$el.find(`.${CLS}-dropdown`);
		this.$toggle = this.$el.find(`.${CLS}-toggle`);
		this.$toggleText = this.$el.find(`.${CLS}-toggleText`);
		this.$selectedRegion = this.$el.find(`.${CLS}-selectedRegion`);
		this.$selectedRegionName = this.$el.find(`.${CLS}-selectedRegionName`);
		this.$changeBtn = this.$el.find(`.${CLS}-changeBtn`);
		this.$regionItems = this.$el.find(`.${CLS}-region`);
		this.$storeList = this.$el.find(`.${CLS}-storeList`);
		this.$storeItems = this.$el.find(`.${CLS}-store`);
		this.isSetStore = this.$el.attr('not-set-store') === undefined;

		this.dropdownValue = {
			selectedStore: '',
			selectedStoreName: '',
			selectedRegion: '',
			selectedRegionName: '',
		};
	}

	init() {
		this.initCustomEvent();
		this.checkLocalStorage();
		this.handleDropdown();
		this.handleRegionClick();
		this.handleStoreClick();
		this.handleChangeBtn();
	}

	initCustomEvent() {
		this.el.addEventListener(EVT_SET_REGION, (e) => {
			let storeValue = e.detail;
			this.dropdownValue = storeValue;

			// set region
			this.$selectedRegionName.text(`Region: ${this.dropdownValue.selectedRegionName}`);
			this.$regionItems.removeClass(CLS_IS_SELECTED);
			this.$el.find(`.${CLS}-region[data-id="${this.dropdownValue.selectedRegion}"]`).addClass(CLS_IS_SELECTED);
			this.$el.find(`.${CLS}-storeList[data-region-id="${this.dropdownValue.selectedRegion}"]`).addClass(CLS_IS_SELECTED);

			// set store
			this.$storeItems.removeClass(CLS_IS_SELECTED);
			this.$el.find(`.${CLS}-store[data-id="${this.dropdownValue.selectedStore}"]`).addClass(CLS_IS_SELECTED);
			this.$toggleText.text(this.dropdownValue.selectedStoreName);
		});
	}

	checkLocalStorage() {
		if (this.isSetStore && isLoggedin()) {
			// check if there's store selected
			let $selectedStore = this.$el.find(`.${CLS}-store.${CLS_IS_SELECTED}`);
			if ($selectedStore && $selectedStore.length > 0) {
				let $selectedRegion = this.$el.find(`.${CLS}-region.${CLS_IS_SELECTED}`);
				this.dropdownValue = {
					selectedStore: $selectedStore.data('id'),
					selectedStoreName: $selectedStore.text(),
					selectedRegion: $selectedRegion.data('id'),
					selectedRegionName: $selectedRegion.text(),
				};
			}
		} else if (this.isSetStore) {
			if (window.localStorage) {
				let storeValue = window.localStorage.getItem(`bris.findInStore.value`);
				if (storeValue) {
					this.dropdownValue = JSON.parse(storeValue);

					this.$el.find(`.${CLS}-region[data-id="${this.dropdownValue.selectedRegion}"]`).addClass(CLS_IS_SELECTED);
					this.$el.find(`.${CLS}-store[data-id="${this.dropdownValue.selectedStore}"]`).addClass(CLS_IS_SELECTED);
					this.$el.find(`.${CLS}-storeList[data-region-id="${this.dropdownValue.selectedRegion}"]`).addClass(CLS_IS_SELECTED);
					this.$toggleText.text(this.dropdownValue.selectedStoreName);
					this.$selectedRegionName.text(`Region: ${this.dropdownValue.selectedRegionName}`);
					this.$el.addClass(CLS_SHOW_STORE);
				}
			}
		}
	}

	handleDropdown() {
		this.$dropdown.on('show.bs.dropdown', () => {
			if (this.dropdownValue.selectedStore || this.dropdownValue.selectedRegion) {
				this.$el.addClass(CLS_SHOW_STORE);
				this.$el.removeClass(CLS_SHOW_REGION);

				if (this.dropdownValue.selectedRegion) {
					this.$el.find(`.${CLS}-storeList[data-region-id="${this.dropdownValue.selectedRegion}"]`).addClass(CLS_IS_SELECTED);
				}
			} else {
				this.$el.removeClass(CLS_SHOW_STORE);
				this.$el.addClass(CLS_SHOW_REGION);
				this.$toggleText.text(TXT_REGION);
			}
		});

		this.$dropdown.on('hide.bs.dropdown', () => {
			if (this.dropdownValue.selectedStore) {
				this.$toggleText.text(this.dropdownValue.selectedStoreName);
			} else {
				this.$toggleText.text(TXT_STORE);
			}
		});
	}

	handleRegionClick() {
		this.$regionItems.each((i, regionEl) => {
			$(regionEl).on('click', (e) => {
				e.stopPropagation();
				this.$el.addClass(CLS_SHOW_STORE);
				this.$el.removeClass(CLS_SHOW_REGION);
				this.$toggleText.text(TXT_STORE);

				let $target = $(regionEl);
				this.dropdownValue.selectedRegion = $target.data('id');
				this.dropdownValue.selectedRegionName = $target.text().trim();

				this.$regionItems.removeClass(CLS_IS_SELECTED);
				$target.addClass(CLS_IS_SELECTED);
				this.$selectedRegionName.text(`Region: ${this.dropdownValue.selectedRegionName}`);

				this.$storeList.removeClass(CLS_IS_SELECTED);
				this.$el.find(`.${CLS}-storeList[data-region-id="${this.dropdownValue.selectedRegion}"]`).addClass(CLS_IS_SELECTED);
			});
		});

		this.$selectedRegion.on('click', (e) => {
			e.stopPropagation();
			this.changeRegion();
		});
	}

	handleStoreClick() {
		this.$storeItems.each((i, storeEl) => {
			$(storeEl).on('click', (e) => {
				this.$el.addClass(CLS_SHOW_STORE);
				this.$el.removeClass(CLS_SHOW_REGION);
				if (this.isSetStore) {
					this.$toggle.prop('disabled', true);
					this.$el.addClass(CLS_IS_LOADING);
					spinnerService.appendTo(this.$toggle, true);
				}

				let $target = $(storeEl);
				this.dropdownValue.selectedStore = $target.data('id');
				this.dropdownValue.selectedStoreName = $target.text().trim();

				this.$storeItems.removeClass(CLS_IS_SELECTED);
				$target.addClass(CLS_IS_SELECTED);

				// select region on storeAvailability
				let storeAvailabilityEl = document.querySelector('[data-wg="StoreAvailability"]');
				if (storeAvailabilityEl) {
					let evt = new CustomEvent('storeAvailability.setRegion', {detail: this.dropdownValue});
					storeAvailabilityEl.dispatchEvent(evt);
				}

				this.isSetStore && saveSelectedStore(this.dropdownValue, () => {
					this.$toggle.prop('disabled', false);
					this.$el.removeClass(CLS_IS_LOADING);
					spinnerService.removeFrom(this.$toggle);
				});
			});
		})
	}

	handleChangeBtn() {
		this.$changeBtn.on('click', (e) => {
			e.stopPropagation();
			this.changeRegion();
		});
	}

	changeRegion() {
		this.$toggleText.text(TXT_REGION);
		this.reset();
	}

	reset() {
		this.$el.removeClass(CLS_SHOW_STORE);
		this.$el.addClass(CLS_SHOW_REGION);
		this.$storeList.removeClass(CLS_IS_SELECTED);
		this.dropdownValue.selectedStore = '';
		this.dropdownValue.selectedStoreName = '';
	}
}



// WEBPACK FOOTER //
// D:/AzureDevops/vsts-agent-win-x64-2.202.1_04/_work/408/s/FrontEnd/src/views/widgets/regionStoreSelector/js/regionStoreSelector.js